<script>
  // Imports
  import { intcomma } from 'journalize';
  import { getSortByString, getSortByNumber } from '../../utils/sorters';

  // Input
  export let data;
  export let metadata;

  data = data.filter(
    (d) =>
      d.confirmed_and_probable_cases >= 10 &&
      d.doubling_time_cases != null &&
      d.doubling_time_cases > 0.0
  );

  // Table row limit
  const limit = 10;
  let showAll = false;

  // The default type setting
  let sortAttr = 'doubling_time_cases';
  let sortAscending = true;

  // Get table headers based on type
  const headerList = [
    { text: 'County', class: 'text-left sortable', attr: 'county' },
    {
      text: 'Total cases',
      class: 'text-right sortable',
      attr: 'confirmed_and_probable_cases',
    },
    {
      text: 'Last 7 days',
      class: 'text-right sortable',
      attr: 'new_confirmed_and_probable_cases_seven_day_total',
    },
    {
      text: 'Days to double',
      class: 'text-right sortable',
      attr: 'doubling_time_cases',
    },
  ];

  const countyFormat = (d) => {
    return metadata[d.fips].url
      ? `<a href="${metadata[d.fips].url}">${d.county} &raquo;</a>`
      : d.county;
  };
  const intFormat = (value) => {
    if (value >= 0) {
      return intcomma(value);
    } else {
      return '&ndash;';
    }
  };
  const doubleFormat = (value) => {
    if (value == null) {
      return '&ndash;';
    } else if (value >= 0) {
      return intcomma(value.toFixed(1));
    } else {
      return '&ndash;';
    }
  };

  const rowFormat = (d) => ({
    header: countyFormat(d),
    values: [
      {
        text: intFormat(d.confirmed_and_probable_cases),
        class: 'text-right',
      },
      {
        text: intFormat(d.new_confirmed_and_probable_cases_seven_day_total),
        class: 'text-right',
      },
      {
        text: doubleFormat(d.doubling_time_cases),
        class: 'text-right',
      },
    ],
  });

  const getTableRows = (arr, sortAttr, sortAscending) => {
    // Sort the data
    const sortFunc =
      sortAttr == 'county'
        ? getSortByString(sortAttr, sortAscending)
        : getSortByNumber(sortAttr, sortAscending);
    arr.sort(sortFunc);

    // Return the array formatted for our template
    return arr.map(rowFormat);
  };
  $: sortedData = getTableRows(data, sortAttr, sortAscending);

  function onToggle() {
    showAll = !showAll;
  }

  function onSort(e) {
    const thisAttr = e.target.getAttribute('data-attr');
    if (thisAttr === sortAttr) {
      sortAscending = !sortAscending;
    } else {
      sortAttr = thisAttr;
      if (thisAttr == 'county') {
        sortAscending = true;
      } else {
        sortAscending = false;
      }
    }
  }
</script>

<div style="margin-top: 20px;">
  <table class="dg-table">
    <thead>
      <tr>
        {#each headerList as obj}
          <th
            scope="col"
            data-attr={obj.attr}
            class={obj.class}
            class:sort-asc={sortAttr === obj.attr && sortAscending}
            class:sort-desc={sortAttr === obj.attr && !sortAscending}
            on:click={onSort}
          >
            {obj.text}
          </th>
        {/each}
      </tr>
    </thead>
    <tbody>
      {#each sortedData as obj, idx}
        <tr class:display-none={idx + 1 > limit && !showAll}>
          <th scope="col" class="text-left">
            {@html obj.header}
          </th>
          {#each obj.values as column}
            <td class={column.class} style={column.style}>
              {@html column.text}
            </td>
          {/each}
        </tr>
      {/each}
    </tbody>
  </table>
  <div class="text-center">
    <button class="btn" on:click={onToggle}>
      {showAll ? 'Show less' : 'Show all'}
    </button>
  </div>
</div>
